import { create } from "zustand";
import type { Diagnostic } from "vscode-languageserver-protocol";

interface DiagnosticsState {
	environmentId: string | null;
	byPath: Record<string, Diagnostic[]>;
	/**
	 * 1 ファイル分の診断を反映する。保持中の環境と異なればその環境の診断へ切り替え、
	 * 空配列ならそのファイルの診断エントリを取り除く。
	 */
	setFileDiagnostics: (environmentId: string, path: string, diagnostics: Diagnostic[]) => void;
	/** すべての診断を初期化する (チャット・環境の切り替え時に呼ぶ)。 */
	clear: () => void;
	/** 指定した環境の診断のみ初期化する。既に別環境の診断に切り替わっていれば何もしない。 */
	clearIfEnvironment: (environmentId: string) => void;
}

export const useDiagnosticsStore = create<DiagnosticsState>((set) => ({
	environmentId: null,
	byPath: {},
	setFileDiagnostics: (environmentId, path, diagnostics) =>
		set((state) => {
			if (state.environmentId !== environmentId) {
				return {
					environmentId,
					byPath: diagnostics.length > 0 ? { [path]: diagnostics } : {},
				};
			}
			if (diagnostics.length === 0) {
				if (!(path in state.byPath)) return state;
				const byPath = { ...state.byPath };
				delete byPath[path];
				return { byPath };
			}
			return { byPath: { ...state.byPath, [path]: diagnostics } };
		}),
	clear: () =>
		set((state) =>
			state.environmentId === null && Object.keys(state.byPath).length === 0
				? state
				: { environmentId: null, byPath: {} },
		),
	clearIfEnvironment: (environmentId) =>
		set((state) =>
			state.environmentId === environmentId ? { environmentId: null, byPath: {} } : state,
		),
}));
